import { Token } from '@/domain/types/Token'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

import { CommonDialogProps, DialogConfig } from '../common/types'
import { BorrowDialogContentContainer } from './BorrowDialogContentContainer'
import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { useEffect } from 'react'
import { track } from '@/features/analytics'

export interface BorrowDialogProps extends CommonDialogProps {
  token: Token
}

function BorrowDialog({ token, open, setOpen }: BorrowDialogProps) {
  const isWrongNetwork = useWrongNetwork()

  useEffect(() => {
    track('lend_borrow_asset_selected', {
      token: token.symbol,
      market: token.address,
      market_type: 'standard',
      action_type: 'borrow',
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <BorrowDialogContentContainer token={token} closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const borrowDialogConfig: DialogConfig<BorrowDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: BorrowDialog,
}
